import React, { FC } from 'react';
import { useFeatureFlags } from '../unleash';
import { Overview as New } from './OverviewNew';
import { Overview as Old } from './Overview';

export const OverviewToggle: FC = () => {
  const { revisionsNewOverview } = useFeatureFlags();
  if (revisionsNewOverview) {
    return <New />;
  }
  return <Old />;
};
